<template>
  <div class="loginBg">
    <login-dialog ref="_loginDialog" @loginSuc="loginSuc"></login-dialog>
  </div>
</template>

<script>
import * as Router from '@/utils/constant_router.js'
import { isEmpty } from '@/utils/strUtils'
import loginDialog from '@/components/dialog/loginDialog'

export default {
  components: {
    loginDialog
  },
  data() {
    return {
      user: '',
      pwd: ''
      // user: "admin",
      // pwd: "uic2020",
    }
  },
  created() {
    // 初始化 进行 自动登录
    localStorage.removeItem('meunList')
    this.$nextTick(() => {
      this.$refs._loginDialog.show()
      this.bindAisInfoFieldArr()
    })
  },
  methods: {
    bindAisInfoFieldArr() {
      this.$api
        .bindAisInfoFieldArr({})
        .then(({ data }) => {
          let regionOptions = []
          let country = data.Data.country
          let province = data.Data.province
          country.forEach(info => {
            let item = {}
            if (info == '中国') {
              item.children = []
              province.forEach(p => {
                let itemP = {}
                itemP.value = itemP.label = p.province
                item.children.push(itemP)

                itemP.children = []
                p.city.forEach(c => {
                  let itemC = {}
                  itemC.value = itemC.label = c
                  itemP.children.push(itemC)
                })
              })
            }
            item.value = item.label = info
            regionOptions.push(item)
            localStorage.setItem('options_region', JSON.stringify(regionOptions))
          })
          this.autoLogin()
        })
        .catch(({ error }) => {
          console.log(error)
        })
    },
    autoLogin() {
      var token = localStorage.getItem('token')
      if (!isEmpty(token)) {
        this.$api
          .autoLogin({
            token: token
          })
          .then(({ data }) => {
            this.loginSuc()
          })
          .catch(({ error }) => {})
      }
    },
    // 登录成功
    loginSuc() {
      this.$api
        .getNav({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.navList = []
          this.navWaList = []
          data.Data.forEach((nav, index) => {
            if (Router.navList(nav.id)) {
              if (nav.id == 21) {
                this.navList.splice(6, 0, nav)
              } else {
                this.navList.push(nav)
              }
            }
            if (Router.navWaList(nav.id)) {
              this.navWaList.push(nav)
            }
          })
          localStorage.setItem('showDataMunu', true)
          localStorage.setItem('showWAMunu', true)
          localStorage.setItem('navList', JSON.stringify(this.navList))
          localStorage.setItem('navWaList', JSON.stringify(this.navWaList))
          let meun = Router.getFirstMeun(this.navList)
          if (meun == null) {
            meun = Router.getFirstMeun(this.navWaList)
          }
          if (meun == null) {
            this.$message.error('用户无权限')
          } else {
            meun.listPath = Router.getMeunRouter4MeunId(meun.id)
            localStorage.setItem('meunItem', JSON.stringify(meun))
            this.$router.push(meun.listPath)
          }
        })
        .catch(({ error }) => {})
    }
  }
}
</script>

<style lang="less">
.loginBg {
  width: 100%;
  height: 100vh;
  background: url(/static/img/login_bg.png);
}
</style>


// WEBPACK FOOTER //
// src/pages/login.vue